import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    scrollToSection(event) {
        event.preventDefault();

        const href = event.currentTarget.href;
        const hash = new URL(href).hash; // includes the leading "#"

        if (!hash) return;

        const targetId = hash.slice(1); // remove "#" safely here
        const target = document.getElementById(targetId);
        const offset = 50;

        if (target) {
            const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: y,
                behavior: "smooth"
            });

            // Премахва hash от URL-а, без да презарежда
            history.replaceState(null, "", window.location.pathname);
        }
    }
}
